/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Completeness_DescriptionInputs */

const en_score_completeness_description = /** @type {(inputs: Score_Completeness_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your resume should contain all the important information: personal details, education, practical experience, IT and language skills, and soft skills. Your education and work experience must include start and end dates (month/year) so that your career path is easy to follow. Recruiters pay attention to completeness because they need to quickly understand who you are, what you are studying, and what experience and skills you have.`)
};

const de_score_completeness_description = /** @type {(inputs: Score_Completeness_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Lebenslauf sollte alle wichtigen Informationen enthalten: persönliche Daten, Studium, praktische Erfahrungen, IT- und Sprachkenntnisse sowie Soft Skills. Studium und Berufserfahrung müssen mit Start- und Enddatum (Monat/Jahr) angegeben sein, damit dein Werdegang nachvollziehbar ist. Recruiter achten auf Vollständigkeit, weil sie schnell verstehen müssen, wer du bist, was du studierst und welche Erfahrungen und Fähigkeiten du hast.`)
};

/**
* | output |
* | --- |
* | "Your resume should contain all the important information: personal details, education, practical experience, IT and language skills, and soft skills. Your ed..." |
*
* @param {Score_Completeness_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const score_completeness_description = /** @type {((inputs?: Score_Completeness_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Completeness_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_score_completeness_description(inputs)
	return en_score_completeness_description(inputs)
});